export { default } from './StrategyCenterMarker';
